/* eslint-disable import/prefer-default-export */
export function createRedirectionLink({
  parkingType, carparkId, reference, licensePlate,
}) {
  let redirectionLink = '/';
  if (parkingType === 'BOOKING' && carparkId && reference) redirectionLink = `#/carparks/${carparkId}/bookings?filters=reference%3Ailike%3A${reference}&pagination=1%2C20`;
  if (parkingType === 'ON_DEMAND' && carparkId && reference) redirectionLink = `#/carparks/${carparkId}/on_demands?filters=reference%3Ailike%3A${reference}&pagination=1%2C20`;
  if ((parkingType === 'REGULAR' || parkingType === 'ASSIGNED') && carparkId && licensePlate) redirectionLink = `#/carparks/${carparkId}/access_rights?filters=licensePlate%3Ailike%3A${licensePlate}&pagination=1%2C20`;

  return redirectionLink;
}
// TODO Ajouter le tri par référence pour les regular et les assigned



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/utils/utils.js